
import React from "react";

interface LoadingSpinnerProps {
  error?: Error | null;
  retry?: () => void;
}

const LoadingSpinner = ({ error, retry }: LoadingSpinnerProps) => (
  <div className="flex flex-col items-center justify-center min-h-screen">
    {error ? (
      <div className="text-center">
        <p className="text-red-500 mb-2">Failed to load module</p>
        <button 
          onClick={retry} 
          className="px-4 py-2 bg-emu-blue text-white rounded-md hover:bg-blue-600"
        >
          Retry
        </button>
      </div>
    ) : (
      <div className="w-12 h-12 border-4 border-emu-blue border-t-transparent rounded-full animate-spin"></div>
    )}
  </div>
);

export default LoadingSpinner;
